import type {SingleUsePaymentToken} from '../../../../../transport/types/checkout';

import type {GooglePayPayment} from './types';

/**
 * Build single_use_payment_token for checkout API (Google Pay path).
 *
 * Google Pay's tokenizationData.token is ALREADY a JSON string (unlike Apple
 * Pay's payment.token which is an object). Pass through directly — wrapping
 * with JSON.stringify would double-encode and break gateway decryption.
 *
 * @param payment Google Pay PaymentData from loadPaymentData() or Android show()
 * @param paymentServiceId Google Pay service ID from backend config
 */
export function buildSingleUsePaymentToken(
  payment: GooglePayPayment,
  paymentServiceId: string,
): SingleUsePaymentToken {
  return {
    payment_service_id: paymentServiceId,
    token: payment.paymentMethodData.tokenizationData.token,
  };
}
